export enum ResourceTypes {
	GROUP = 'Group',
	ACTIVITY = 'Activity',
	SESSION = 'Session'
}
